<template>
  <div class="upload-image">
    <el-upload
      :action="action"
      list-type="picture-card"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :multiple="multiple"
      :drag="drag"
      :limit="limit"
      :disabled="disabled"
      :before-upload="beforeUpload"
      :on-exceed="handleExceed"
      :file-list="fileList"
      :on-success="uploadSuccess"
    >
      <i class="el-icon-plus"></i>
      <div slot="tip" class="el-upload__tip" v-text="tip"></div>
    </el-upload>
    <PreviewByFileId
      v-if="fileId"
      :value="previewModal"
      :fileId="fileId"
      @change="e => (previewModal = e)"
    />
  </div>
</template>

<script>
import FormConfig from "../formConfig"; // 表单配置
import PreviewByFileId from "./previewByFileId"; // 文件预览组件
// 图片
export default {
  name: "UploadImage",
  components: {
    PreviewByFileId
  },
  props: {
    value: {
      type: [String, Number, Array],
      default: ""
    }
  },
  data() {
    return {
      dataModel: this.value,
      size: FormConfig.config.size,
      action: workFlowConfig.configApi.fileUploadApi,
      fileList: [],
      previewModal: false, // 预览窗口
      fileId: "",
      fileUrl: "",
      fileName: "",
      showFrame: false
    };
  },
  computed: {
    multiple() {
      let element = this.$parent.element || this.$parent.widget;
      let status = !!element.options.multiple;
      return status;
    },
    drag() {
      let element = this.$parent.element || this.$parent.widget;
      let status = !!element.options.drag;
      return status;
    },
    limit() {
      let element = this.$parent.element || this.$parent.widget;
      let status = element.options.limit || 0;
      return status;
    },
    tip() {
      let element = this.$parent.element || this.$parent.widget;
      let status = element.options.tip || "";
      return status;
    },
    disabled() {
      let element = this.$parent.element || this.$parent.widget;
      let status = !!element.options.disabled;
      return status;
    },
    fileSize() {
      let element = this.$parent.element || this.$parent.widget;
      let status = element.options.fileSize || 5;
      return status;
    }
  },
  watch: {
    value(val) {
      this.init();
    },
    dataModel(val) {
      this.$emit("input", val);
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化
    init() {
      this.dataModel = this.value;
      if (typeof this.value === "object") {
        let files = _.cloneDeep(this.value);
        this.initArray(files);
        return;
      }
      if (this.value.includes("[{")) {
        let str = this.value
          .replace(/{/g, '{"')
          .replace(/}/g, '"}')
          .replace(/, /g, '", "')
          .replace(/}"/g, "}")
          .replace(/"{/g, "{")
          .replace(/=/g, '":"');
        let files = JSON.parse(str);
        this.initArray(files);
        return;
      }
    },
    // 初始化数据
    initArray(array) {
      array.map(item => {
        item.url = item.fileUrl;
        item.response = {
          data: item
        };
      });
      this.fileList = array;
    },
    // 预览
    handlePreview(file) {
      let datas = file.response.data;
      this.fileId = datas.id;
      this.previewModal = true;
    },
    // 上传前验证
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < this.fileSize;
      if (!isJPG) {
        this.$message.error("上传的图片只能是 jpg或者png 格式!");
      }
      if (!isLt2M) {
        this.$message.error(`上传图片大小不能超过 ${this.fileSize}MB!`);
      }
      return isJPG && isLt2M;
    },
    // 上传限制
    handleExceed(files, fileList) {
      this.$message.error(
        `当前限制选择 ${this.limit} 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      );
    },
    // 删除数据
    handleRemove(file, fileList) {
      this.changeData(fileList);
    },
    // 数据改变
    changeData(array) {
      let list = [];
      array.map(e => {
        let data = e.response ? e.response.data : {};
        list.push({
          name: e.name,
          id: data.id,
          fileUrl: data.fileUrl
        });
      });
      this.$emit("input", list);
    },
    // 上传成功
    uploadSuccess(res, file, fileList) {
      this.changeData(fileList);
    }
  }
};
</script>
<style lang="less" scoped>
.upload-image {
  /deep/.el-upload--picture-card,
  /deep/.el-upload-list--picture-card .el-upload-list__item {
    width: 100px;
    height: 100px;
  }
  /deep/.el-upload--picture-card {
    line-height: 100px;
  }
}
</style>
